<template>
    <transition-group name="fade">

            <!-- Statistiques principales -->
            <div class="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-3 gap-6 mb-8">
                <!-- Emprunts -->
                <div class="bg-gradient-to-r from-[#2A4493]/5 to-[#2A4493]/15 p-6 rounded-lg border border-blue-200">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <div class="w-8 h-8 bg-[#2A4493] rounded-lg flex items-center justify-center">
                                <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.746 0 3.332.477 4.5 1.253v13C19.832 18.477 18.246 18 16.5 18c-1.746 0-3.332.477-4.5 1.253"></path>
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4">
                            <p class="text-sm font-medium text-blue-600">Total emprunts</p>
                            <p class="text-2xl font-bold text-blue-900">{{ props.loans.length }}</p>
                            <p class="text-xs text-blue-500">{{ empruntsEnCours.length }} en cours</p>
                        </div>
                    </div>
                </div>

                <!-- Lectures sur place -->
                <div class="bg-gradient-to-r from-green-50 to-green-100 p-6 rounded-lg border border-green-200">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <div class="w-8 h-8 bg-green-500 rounded-lg flex items-center justify-center">
                                <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4">
                            <p class="text-sm font-medium text-green-600">Reservations</p>
                            <p class="text-2xl font-bold text-green-900">{{ props.reservations.length }}</p>
                        </div>
                    </div>
                </div>

                <!-- Consultations -->
                <div class="bg-gradient-to-r from-orange-50 to-orange-100 p-6 rounded-lg border border-orange-200">
                    <div class="flex items-center">
                        <div class="flex-shrink-0">
                            <div class="w-8 h-8 bg-orange-500 rounded-lg flex items-center justify-center">
                                <svg class="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path>
                                </svg>
                            </div>
                        </div>
                        <div class="ml-4">
                            <p class="text-sm font-medium text-orange-600">Consultations</p>
                            <p class="text-2xl font-bold text-orange-900">{{ props.consultations.length }}</p>
                            <p class="text-xs text-orange-500">Consultations sur place</p>
                        </div>
                    </div>
                </div>

            </div>

            <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div class="bg-white p-6 rounded-lg shadow-sm">
                    <h3 class="text-lg font-semibold text-gray-900 mb-4">Emprunts en cours</h3>
                    <div v-if="!empruntsEnCours.length" class="flex flex-col items-center justify-center py-10 text-gray-500">
                        <svg xmlns="http://www.w3.org/2000/svg" class="h-12 w-12 mb-4 text-gray-400" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        <p class="text-base">Aucun emprunt en cours</p>
                        <p class="text-sm">Vous pouvez en faire un depuis la bibliothèque</p>
                        <a :href="homeRoute"
                           class="mt-2 inline-flex items-center px-4 py-2 bg-[#304491] text-white text-sm font-medium rounded-lg hover:bg-[#ec8054] transition-colors">
                            Explorer la bibliothèque
                        </a>
                    </div>

                    <div class="space-y-3">
                        <div
                            v-for="loan in empruntsEnCours"
                            :key="loan.id"
                            :class="[
                                'flex items-center justify-between p-3 rounded-lg',
                                loan.status === 'ok' ? 'bg-blue-50' :
                                loan.status === 'warning' ? 'bg-orange-50' :
                                'bg-green-50'
                              ]"
                        >
                            <div>
                                <p class="font-medium text-gray-900">{{ loan.title }}</p>
                                <p class="text-sm text-gray-600">{{ loan.author  }}</p>
                            </div>
                            <div class="text-right">
                                <p :class="[
                                      'text-sm font-medium',
                                      loan.status === 'ok' ? 'text-blue-600' :
                                      loan.status === 'warning' ? 'text-orange-600' :
                                      'text-green-600'
                                    ]">{{ loan.expected_return_date }}</p>
                                <p :class="[
                                      'text-xs',
                                      loan.status === 'warning' ? 'text-red-500' : 'text-gray-500'
                                    ]">{{ loan.restant==0?'Dépassé':loan.restant }}</p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Graphique en secteurs avec tooltip -->
                <div class="bg-white p-6 rounded-lg shadow-sm">
                    <h3 class="text-lg font-semibold text-gray-900 mb-4">Répartition de vos activités</h3>
                    <div class="h-80 relative">
                        <canvas
                            ref="pieChart"
                            class="w-full h-full cursor-crosshair"
                            @mousemove="handleMouseMove"
                            @mouseleave="hideTooltip"
                        ></canvas>

                        <!-- Légende -->
                        <div class="flex justify-center gap-4 text-sm ">
                            <div class="flex items-center gap-2">
                                <div class="w-3 h-3 bg-[#2A4493] rounded-full"></div>
                                <span class="text-gray-600">Emprunts</span>
                            </div>
                            <div class="flex items-center gap-2">
                                <div class="w-3 h-3 bg-green-500 rounded-full"></div>
                                <span class="text-gray-600">Réservations</span>
                            </div>
                            <div class="flex items-center gap-2">
                                <div class="w-3 h-3 bg-orange-500 rounded-full"></div>
                                <span class="text-gray-600">Consultations</span>
                            </div>
                        </div>

                        <!-- Tooltip -->
                        <div
                            ref="tooltip"
                            class="absolute bg-gray-800 text-white px-3 py-2 rounded-lg shadow-lg pointer-events-none opacity-0 transition-opacity duration-200 text-sm z-10"
                            style="transform: translate(-50%, -100%)"
                        >
                            <div ref="tooltipContent"></div>
                            <div class="absolute top-full left-1/2 transform -translate-x-1/2 w-0 h-0 border-l-4 border-r-4 border-t-4 border-transparent border-t-gray-800"></div>
                        </div>
                    </div>
                </div>
            </div>

    </transition-group>
</template>

<script setup>
import { ref, onMounted, nextTick, computed } from 'vue'
const pieChart = ref(null)
const tooltip = ref(null)
const tooltipContent = ref(null)

const props = defineProps({
    route: String,
    homeRoute: String,
    defaultImg: String,
    consultations: [Object, null],
    loans: [Object, null],
    reservations: [Object, null],
})

const showRoute = (id) => {
    if (!id || !props.route) return '#'
    return props.route.replace('id', id)
}

const empruntsEnCours = props.loans?.filter(loan => loan.loan_status === "active" && !loan.actual_return_date) || []


// Données pour le graphique en secteurs
const activityDistribution = [
    { name: 'Emprunts', value: props.loans?.length, color: '#2A4493' },
    { name: 'Consultations', value:props.consultations?.length, color:'#F97316' },
    { name: 'Reservations', value: props.reservations.length, color:   '#10B981'}
]

// Variables pour le tooltip
let pieSlices = []

// Fonction pour créer le graphique en secteurs
const createPieChart = () => {
    if (!pieChart.value) return

    const canvas = pieChart.value
    const ctx = canvas.getContext('2d')

    // Redimensionner le canvas
    const rect = canvas.getBoundingClientRect()
    canvas.width = rect.width * window.devicePixelRatio
    canvas.height = rect.height * window.devicePixelRatio
    ctx.scale(window.devicePixelRatio, window.devicePixelRatio)
    canvas.style.width = rect.width + 'px'
    canvas.style.height = rect.height + 'px'

    // Calculs pour centrer le graphique
    const centerX = rect.width / 2
    const centerY = (rect.height - 40) / 2 // -40 pour laisser de la place à la légende
    const radius = Math.min(centerX, centerY) - 20

    const total = activityDistribution.reduce((sum, item) => sum + item.value, 0)

    ctx.clearRect(0, 0, rect.width, rect.height)

    let currentAngle = -Math.PI / 2
    pieSlices = [] // Reset des slices pour le tooltip

    activityDistribution.forEach((item, index) => {
        const sliceAngle = (item.value / total) * 2 * Math.PI

        // Stocker les informations de la slice pour le tooltip
        pieSlices.push({
            centerX,
            centerY,
            radius,
            startAngle: currentAngle,
            endAngle: currentAngle + sliceAngle,
            ...item
        })

        // Dessiner la portion
        ctx.beginPath()
        ctx.moveTo(centerX, centerY)
        ctx.arc(centerX, centerY, radius, currentAngle, currentAngle + sliceAngle)
        ctx.closePath()
        ctx.fillStyle = item.color
        ctx.fill()

        // Bordure blanche
        ctx.strokeStyle = '#ffffff'
        ctx.lineWidth = 2
        ctx.stroke()

        // Texte avec pourcentage
        const textAngle = currentAngle + sliceAngle / 2
        const textRadius = radius * 0.7
        const textX = centerX + Math.cos(textAngle) * textRadius
        const textY = centerY + Math.sin(textAngle) * textRadius

        ctx.fillStyle = 'white'
        ctx.font = 'bold 14px sans-serif'
        ctx.textAlign = 'center'
        ctx.textBaseline = 'middle'
        ctx.fillText(`${Math.round((item.value / total) * 100)}%`, textX, textY)

        currentAngle += sliceAngle
    })
}

// Fonction pour gérer le survol et afficher le tooltip
const handleMouseMove = (event) => {
    const canvas = pieChart.value
    const rect = canvas.getBoundingClientRect()
    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    let hoveredSlice = null

    // Vérifier si la souris est sur une slice
    pieSlices.forEach(slice => {
        const dx = x - slice.centerX
        const dy = y - slice.centerY
        const distance = Math.sqrt(dx * dx + dy * dy)

        if (distance <= slice.radius) {
            let angle = Math.atan2(dy, dx)
            if (angle < 0) angle += 2 * Math.PI

            // Ajuster l'angle pour correspondre à notre système (commencer par le haut)
            angle = (angle + Math.PI / 2) % (2 * Math.PI)

            let startAngle = (slice.startAngle + Math.PI / 2) % (2 * Math.PI)
            let endAngle = (slice.endAngle + Math.PI / 2) % (2 * Math.PI)

            if (startAngle > endAngle) {
                if (angle >= startAngle || angle <= endAngle) {
                    hoveredSlice = slice
                }
            } else {
                if (angle >= startAngle && angle <= endAngle) {
                    hoveredSlice = slice
                }
            }
        }
    })

    if (hoveredSlice) {
        showTooltip(event, hoveredSlice)
    } else {
        hideTooltip()
    }
}

// Fonction pour afficher le tooltip
const showTooltip = (event, slice) => {
    if (!tooltip.value || !tooltipContent.value) return

    const total = activityDistribution.reduce((sum, item) => sum + item.value, 0)
    const percentage = ((slice.value / total) * 100).toFixed(1)

    tooltipContent.value.innerHTML = `
        <strong>${slice.name}</strong><br>
        ${slice.value} activités (${percentage}%)
    `

    const rect = pieChart.value.getBoundingClientRect()
    tooltip.value.style.left = `${event.clientX - rect.left}px`
    tooltip.value.style.top = `${event.clientY - rect.top - 10}px`
    tooltip.value.style.opacity = '1'
}

// Fonction pour cacher le tooltip
const hideTooltip = () => {
    if (tooltip.value) {
        tooltip.value.style.opacity = '0'
    }
}

onMounted(async () => {
    await nextTick()
    createPieChart()

    // Redessiner le graphique lors du redimensionnement
    window.addEventListener('resize', createPieChart)
})
</script>

<style scoped>
.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-to,
.fade-leave-from {
    opacity: 1;
}
canvas {
    max-width: 100%;
    height: 320px;
}

.line-clamp-2 {
    overflow: hidden;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}
</style>
